import { z } from "zod";

/**
 * Contrat partage : le backend valide ses reponses avec ces schemas et le frontend
 * les rejoue a la reception. Une rupture de contrat casse les deux cotes a la compilation.
 */

export const healthSchema = z.object({
  status: z.literal("ok"),
  name: z.string(),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
});
export type Health = z.infer<typeof healthSchema>;

export const readySchema = z.object({
  status: z.enum(["ready", "degraded"]),
  checks: z.object({
    database: z.enum(["up", "down"]),
  }),
});
export type Ready = z.infer<typeof readySchema>;

export const helloQuerySchema = z.object({
  name: z.string().min(1).max(60).optional(),
});
export type HelloQuery = z.infer<typeof helloQuerySchema>;

export const helloSchema = z.object({
  message: z.string(),
  at: z.string(),
});
export type Hello = z.infer<typeof helloSchema>;

export const errorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    requestId: z.string().optional(),
  }),
});
export type ErrorPayload = z.infer<typeof errorSchema>;
